import { Fetcher } from "@/utils/fetcher";
import { AxiosRequestConfig } from "axios";
import { off } from "process";

const blogs = new Fetcher('blogs');
// const product = new Fetcher('product');
blogs.setUseToken(false);

// get brand by slug
export const getBrandBySlug = (slug: string) =>
    blogs.get<BrandItem>(`/storefront/get-one/${slug}`);

// get brand by ids
export const getBrandsByIds = (ids: number[]) =>
    blogs.post<BrandItem []>('/storefront/get-brands-by-ids', { ids });

// "sortBy": "id",
//   "sortOrder": "DESC"
export const getAllBlogs = (limit: number, offset: number,sortBy: string, sortOrder: string,status: string,isPublished: any) =>{
    return blogs.post<any>('/storefront/list', {limit, offset, sortBy, sortOrder, status, isPublished})
}

export const getAllTrendingProducts = (limit: number, page: number, type:string) =>{
    return blogs.post<any>('/trending-products/storefront/list', {limit, page, type})
}

export const getBlogsBySlugs = (slugs:string)=>{
    return blogs.get<any>(`/slug/${slugs}`);
}

// get all brands by filter
// {{apiUrl}}/api/v1/brand/storefront/get-all?perPage&currentPage&search&isFeatured&category=samsung
// interface GetAllBrandsRequest extends Pagination {
//     isFeatured?: boolean;
//     category?: string;
//     sortBy: "id" | "serial_no";
//     sortOrder: "ASC" | "DESC";
//     config?: AxiosRequestConfig<any>;
// }
// export const getAllBrands = ({ config, ...data }: GetAllBrandsRequest) =>
//     brand.get<BrandResponse>(`/storefront/get-all?${brand.buildQuery(data)}`, config);

// // brands by category: /product/storefront/brands-by-category/:slug?perPage=15&currentPage=1
// export const getBrandsByCategory = (categorySlug: string, queryData: GetAllBrandsRequest) => 
//     product.get<BrandResponse>(`/storefront/brands-by-category/${categorySlug}?${product.buildQuery(queryData)}`);